import { LAYOUT_SECTION_TYPE_NAMES } from "@/app/[lang]/[[...slug]]/layoutSectionTypeNames"

export const HERO_SECTION_TYPES = new Set([
  "HeroLead",
  "HeroLeadSearch",
  "FlexibleHero",
  "SimpleHero",
])

// LayoutSubnavigation never renders a heading, so it can never carry the h1.
const NON_LAYOUT_SECTION_TYPES = new Set([
  "LongTextBody",
  "Tabs",
  "LayoutSubnavigation",
])

function hasTrimmedHeader(value: unknown): boolean {
  return typeof value === "string" && value.trim().length > 0
}

export function isHeroSection(
  section: { __typename?: string } | null | undefined,
): boolean {
  return !!section?.__typename && HERO_SECTION_TYPES.has(section.__typename)
}

export function heroHasHeading(section: any): boolean {
  if (!section) return false

  switch (section.__typename) {
    case "SimpleHero":
    case "HeroLeadSearch":
      return hasTrimmedHeader(section.header)
    case "HeroLead":
    case "FlexibleHero":
      return hasTrimmedHeader(section.contentCollection?.items?.[0]?.header)
    default:
      return false
  }
}

function isPromotableLayoutSection(section: any): boolean {
  if (!section?.__typename) return false
  if (section.placeholder === true) return false
  if (NON_LAYOUT_SECTION_TYPES.has(section.__typename)) return false
  return LAYOUT_SECTION_TYPE_NAMES.has(section.__typename)
}

export function findPromotedHeaderIndex(
  sections: any[] | null | undefined,
): number | null {
  if (!sections?.length) return null

  const first = sections[0]
  // A hero without a heading, or a LayoutSubnavigation in the lead slot
  // (neither renders a heading), can't carry the h1 -- promote it forward.
  const firstNeedsPromotion = isHeroSection(first)
    ? !heroHasHeading(first)
    : first?.__typename === "LayoutSubnavigation"
  if (!firstNeedsPromotion) return null

  for (let i = 1; i < sections.length; i++) {
    if (isPromotableLayoutSection(sections[i])) return i
  }

  return null
}

export function resolveHeaderElement(
  sections: any[] | null | undefined,
  index: number,
): "h1" | "h2" {
  const promotedIndex = findPromotedHeaderIndex(sections)
  if (promotedIndex !== null) {
    return index === promotedIndex ? "h1" : "h2"
  }

  return index === 0 ? "h1" : "h2"
}
